export const ds_BusinessDirectoryBlock_Entry = `
    fragment ds_BusinessDirectoryBlock_Entry on ds_BusinessDirectoryBlock_Entry {
        id
        canonicalUid
        
        businessDirectory_Intro
        businessDirectory_FilterByCategory
        businessDirectory_ShowFeatureCategory
        businessDirectory_FeatureCategory {
            id
            slug
        }
        businessDirectory_FeatureSectionHeading
        businessDirectory_MainSectionHeading

        businessDirectory_ContainerWidth
        businessDirectory_BorderAroundCards
        businessDirectory_FeaturedOrientation
        businessDirectory_FeaturedShowDividerLines
        businessDirectory_Orientation
        businessDirectory_ShowDividerLines
        businessDirectory_TopSpacing

        businessDirectory_ColorTheme
        businessDirectory_ColorPalette
        businessDirectory_FullWidthBackground
    }
`